import { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoTooltip from "../../Statistics/Risk/InfoTooltip.jsx";
import { getRiskColor } from "../../../services/Statistics/Risk/riskandRulesEnpoints.js";
import { fetchUseInfoFromQuestionnaires } from "../../../services/Questionnaire/questionnaireEndpoint.js";

const boxStyle = {
  margin: "15px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const typographyStyle = {
  fontSize: "0.95rem",
};
export default function BasicInfoBox({ selectedUser }) {
  const [basicDataFromQuestionnaires, setBasicDataFromQuestionnaires] =
    useState([]);

  const { t } = useTranslation("basicInfo");

  useEffect(() => {
    // console.log("Selected User in BasicInfoBox:", selectedUser);

    fetchUseInfoFromQuestionnaires(
      selectedUser.subject_id,
      setBasicDataFromQuestionnaires
    );
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "white",
        marginTop: 2,
        borderRadius: "20px",
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
          lg: "row",
        },
        gap: {
          xs: "unset",
          sm: "unset",
          md: "3vw",
          lg: "3vw",
        },
      }}
    >
      <Box sx={{ margin: "15px", marginRight: "2vw" }}>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.subjectId")}</strong> {selectedUser?.subject_id}
        </Typography>
      </Box>
      <Box
        sx={{
          ...boxStyle,
        }}
      >
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.age")}</strong> {selectedUser?.age}
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.sex")}</strong> {selectedUser?.sex}
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.height")}</strong> {selectedUser?.height} cm
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.weight")}</strong> {selectedUser?.weight} kg
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.ethnicity")}</strong> {basicDataFromQuestionnaires["ethnicity"]}
        </Typography>
      </Box>
      <Box
        sx={{
          ...boxStyle,
        }}
      >
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.country")}</strong> {basicDataFromQuestionnaires["country"]}
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.smoking")}</strong>{" "}
          {basicDataFromQuestionnaires["smoking"] !== "I have never smoked"
            ? basicDataFromQuestionnaires["formerSmoker"]
            : basicDataFromQuestionnaires["smoking"]}
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.familyHistoryCRC")}</strong>{" "}
          {basicDataFromQuestionnaires["familyHistoryCRC"]}
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <span>
            <strong>{t("labels.risk")}</strong>{" "}
            {selectedUser?.risk != null ? selectedUser.risk : t("risk.notCalculated")}
            {selectedUser?.risk != null && (
              <InfoTooltip
                riskColor={() => getRiskColor(selectedUser.riskData)}
                ruleData={selectedUser.ruleData}
                basicUserInfo={selectedUser}
                riskData={selectedUser.riskData}
              />
            )}
          </span>
        </Typography>
      </Box>

      <Box
        sx={{
          ...boxStyle,
        }}
      >
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.environmentType")}</strong>{" "}
          {basicDataFromQuestionnaires["environmentType"]}
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.housing")}</strong> {basicDataFromQuestionnaires["housing"]}
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.employmentStatus")}</strong>{" "}
          {basicDataFromQuestionnaires["employment"]}
        </Typography>
        <Typography sx={{ ...typographyStyle }}>
          <strong>{t("labels.occupation")}</strong> {basicDataFromQuestionnaires["occupation"]}
        </Typography>
      </Box>
    </Box>
  );
}
